import { frappeList, frappeGet } from "./utils";
import type { Customer } from "./types/customer";
import type { SalesOrder } from "./types/order";

export const customers = {
  /**
   * List all customers
   */
  list(filters?: Record<string, any>): Promise<Customer[]> {
    return frappeList<Customer>("Customer", filters, [
      "name",
      "customer_name",
      "customer_type",
      "customer_group",
      "territory",
    ]);
  },

  /**
   * Get a single customer by name
   */
  detail(customerName: string): Promise<Customer> {
    return frappeGet<Customer>("Customer", customerName);
  },

  /**
   * Get all orders for a customer (fields the Customer sidebar renders)
   */
  orders(customerName: string): Promise<SalesOrder[]> {
    return frappeList<SalesOrder>(
      "Sales Order",
      { customer: customerName },
      [
        "name",
        "transaction_date",
        "status",
        "grand_total",
        "currency",
        "per_billed",
        "total_qty",
        "source_channel",
        "creation",
      ],
    );
  },
};

